import { AnalyticsMetaKeys as key } from './meta-keys'
/**
 *  Permutive Pageview event attributes
 */
export const PermutivePageviewAttributes = [
    key.MAIN_CATEGORY,
    key.BRAND,
    key.DIVISION,
    key.ENV,
    key.TYPE,
    key.VIEW_TYPE,
    key.CAR_MAKE,
    key.CAR_MODEL,
    key.CAR_BODYSTYLE,
    key.CAR_CLASSIFICATION,
    key.REF_DETAILS,
    key.USER_STATUS,
    // Story attributes
    key.SPONSOR_NAME,
    key.ARTICLE_AUTHOR_LIST,
    key.ARTICLE_TAG_LIST,
    key.TITLE,
    key.NLP_CATEGORY_LIST,
    key.NLP_ENTITY_LIST,
    key.NLP_TOPIC_LIST,
    key.SECONDARY_CATEGORIES_LIST
]

/**
 * Permutive Keys Mapping
 */
export const PermutiveKeysMapping: any =  {
    article_author_list: 'article_authors',
    article_tag_list: 'article_tags',
    nlp_category_list: 'nlp_category',
    nlp_entity_list: 'nlp_entity',
    nlp_topic_list: 'nlp_topic',
    secondary_categories_list: 'secondary_categories',
}
